import React, {Fragment, useEffect} from 'react';
import {useDropzone} from 'react-dropzone';
import useUploadFile from '../../hooks/useUploadFile';
import PropTypes from 'prop-types';
import useStateFile from '../../hooks/useStateFile';
import {required} from '../../helpers/ValidateHelper';
import FileNameFiled from './FileNameField';
import {Field, useForm, useFormState} from 'react-final-form';
import Error from './Error';
import {bytesToSize} from '../../../../../common/helpers/FileHelper';

function DropzoneField({name, options, validate, multiple = true, refreshState = true}) {
    const {change} = useForm();
    const {uploadFiles} = useUploadFile(options, refreshState);
    const {files} = useStateFile();
    const {submitFailed, errors} = useFormState();

    useEffect(() => {
        change(`${name}Count`, files.length);
    }, [files]);

    const onDrop = acceptedFiles => {
        if (!multiple) {
            if (files.length > 0) return;
            if (acceptedFiles.length > 0) {
                uploadFiles([acceptedFiles[0]]);
            }
        } else {
            uploadFiles(acceptedFiles);
        }
    };

    const noClick = event => {
        if (event.target.className !== 'browse-file') {
            event.stopPropagation();
        }
    };

    const hasSubmitErrors = () => {
        return submitFailed && (errors[`${name}Count`] || errors.files);
    };

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        multiple,
        noClick: !multiple && files.length > 0,
        noDrag: !multiple && files.length > 0,
    });

    return (
        <Fragment>
            <div className="order-instruction__files">
                <div
                    className={`dropzone ${isDragActive ? 'dz-drag-hover' : ''} ${hasSubmitErrors() ? 'dz-has-error' : ''}`}
                    {...getRootProps({onClick: noClick})}
                >
                    <div className="fallback">
                        <input {...getInputProps()} />
                    </div>

                    <div style={{width: '100%'}}>
                        {files.map((file, index) => (
                            <div key={index}>
                                <FileNameFiled
                                    name={name}
                                    file={file}
                                    index={index}
                                    validate={required('File name can not be empty')}
                                />
                            </div>
                        ))}

                        {(multiple || files.length === 0) && (
                            <>
                                <div className="dropzone-intro-text">
                                    <div className="dropzone-intro-text__icon">
                                        <img src="/_core/assets/themes/v5/assets/img/form3/attach-file-icon.svg" alt="" />
                                    </div>
                                    <p className="drp-lg-text">
                                        drag & drop file or <span className="browse-file">browse</span> from computer
                                    </p>
                                    <p className="drp-sm-text">
                                        <span className="browse-file">browse files</span> from device
                                    </p>
                                </div>
                                {multiple && (
                                    <p className="drp-file-size-text" style={{textAlign: 'center', color: '#8492a6', marginTop: '-7px'}}>
                                        (max 10 files, {bytesToSize(options.sizeMax)} per file)
                                    </p>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
            <Field
                key={typeof validate === 'function' ? 1 : 0}
                name={`${name}Count`}
                type="hidden"
                component="input"
                validate={validate}
            />
            <Error name={`${name}Count`} />
        </Fragment>
    );
}

DropzoneField.propTypes = {
    name: PropTypes.string.isRequired,
    options: PropTypes.object.isRequired,
    validate: PropTypes.any,
    multiple: PropTypes.bool,
    refreshState: PropTypes.bool
};

export default DropzoneField;
